"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMenuSubItem = isMenuSubItem;
exports.isMenuItemExternalLink = isMenuItemExternalLink;
exports.isMenuItemInternalLink = isMenuItemInternalLink;
exports.isMenuItemTopLink = isMenuItemTopLink;
exports.isMenuItemTopWithSubItems = isMenuItemTopWithSubItems;

function isMenuSubItem(item) {
  return !('icon' in item);
}

function isMenuItemExternalLink(item) {
  return 'url' in item;
}

function isMenuItemInternalLink(item) {
  return 'path' in item;
}

function isMenuItemTopLink(item) {
  return isMenuItemInternalLink(item) || isMenuItemExternalLink(item);
}

function isMenuItemTopWithSubItems(item) {
  return 'items' in item;
}